// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1C1Yy","light":"Button_light__3Q60Y","dark":"Button_dark__1y-7d","primary":"Button_primary__3HIvj","disabled":"Button_disabled__2ecBd"};